import { useCallback, useRef } from 'react'

import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import { ConversationFooter } from './components/ConversationFooter'
import messages from './messages'
import { useGlobalCommandView } from './useGlobalCommandView'
import { GlobalCommandModal } from '../../components/GlobalCommandModal'
import { GetGlobalSearchResultsPresenter } from '../../features/get-global-search-results/presenters/GetGlobalSearchResultsPresenter'
import { RunConversationTurnPresenter } from '../../features/run-conversation-turn/presenters/RunConversationTurnPresenter'
import { useGlobalSearchHotkey } from '../../hooks/useGlobalSearchHotkey'
import { ConversationProvider } from '../../providers/ConversationProvider'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const GlobalCommandView = () => {
  const intl = useProcurifyIntl()
  const DATA_2061_GUIDED_INTAKE_ORDERS = useFeatureFlag(
    'DATA_2061_GUIDED_INTAKE_ORDERS'
  )
  const { isOpen, open, close } = useGlobalSearch()
  const {
    data,
    methods: { startConversation, endConversation },
  } = useGlobalCommandView()
  const searchInputRef = useRef<HTMLInputElement>(null)

  useGlobalSearchHotkey(open)

  const focusSearchInput = () => {
    searchInputRef.current?.focus()
  }

  const handleClose = useCallback(() => {
    endConversation()
    close()
  }, [endConversation, close])

  const conversationQuery = DATA_2061_GUIDED_INTAKE_ORDERS
    ? data.initialQuery
    : null
  const isConversation = conversationQuery !== null

  const modal = (
    <GlobalCommandModal
      isOpen={isOpen}
      onClose={handleClose}
      onEntered={focusSearchInput}
      isConversation={isConversation}
      title={intl.formatMessage(messages.conversationTitle)}
      footer={isConversation ? <ConversationFooter /> : undefined}
    >
      {isConversation ? (
        <RunConversationTurnPresenter />
      ) : (
        <GetGlobalSearchResultsPresenter
          key={isOpen ? 'open' : 'closed'}
          inputRef={searchInputRef}
          onClose={handleClose}
          onHandoff={
            DATA_2061_GUIDED_INTAKE_ORDERS ? startConversation : undefined
          }
        />
      )}
    </GlobalCommandModal>
  )

  if (conversationQuery === null) {
    return modal
  }

  return (
    <ConversationProvider initialQuery={conversationQuery}>
      {modal}
    </ConversationProvider>
  )
}
